import type { IPathBaseParam } from "./path";
import type { IUserMeVerifyEmailResponse } from "./types";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import { complete } from "@api/users/me/verifyUserEmail/complete/api";

const postApis = createPostApi<
  IApiResponse<IUserMeVerifyEmailResponse>,
  IPathBaseParam,
  undefined
>("users.me.verifyUserEmail");

export const verifyUserEmail = {
  ...postApis,
  complete,
};
